import React, { memo, useMemo } from "react";
import { RelationshipToPolicyHolderTypes, RelationshipToPolicyHolderTypes_Descriptions } from "csd.phoenix.models/RelationshipToPolicyHolderTypes";
import { getEnumValues } from '../../../../../../utils/objectUtils';
import { IFieldOption, IRelationshipToInsuredFieldProps } from "../../../models";
import SelectField from "../../SelectField";
import useFormContext from "../../../FormContext";
import usePromiseState from "../../../../usePromiseState";


// const list: IFieldOption[] = [
//   {"value": 1, "text": "Self"},
//   {"value": 2, "text": "Spouse"},
//   {"value": 3, "text": "Child"},
//   {"value": 4, "text": "Employee"},
//   {"value": 5, "text": "Handicapped Dependent"},
//   {"value": 6, "text": "Life Partner"},
//   {"value": 7, "text": "Dependent" }
// ];

const getSpanishList = (): Promise<IFieldOption[]> => {

    return import(/* webpackChunkName: "insuredrelationship-spanish" */ "./SpanishRelationshipToInsured.json").then(m => m.default);
}


const getFieldList = () => {

  const options: IFieldOption[] = getEnumValues(RelationshipToPolicyHolderTypes)
    .filter(v => v !== RelationshipToPolicyHolderTypes.Unknown)
    .map((value) => ({
      value,
      text: RelationshipToPolicyHolderTypes_Descriptions[value]
    }));

  return options;

}

const RelationshipToInsuredField: React.FC<IRelationshipToInsuredFieldProps> = memo((props) => {
  const { isPrinting, locale } = useFormContext();
  const isSpanish = locale === "es-US";
  const promise = useMemo(() => isPrinting || !isSpanish ? Promise.resolve([]) : getSpanishList(), [isPrinting, isSpanish]);
  const [isLoading, result] = usePromiseState(promise);
  const options = useMemo(() => getFieldList(), []);

  if (isSpanish)
    return <SelectField {...props} options={result || []} isLoading={isLoading} />
  else
    return <SelectField {...props} options={options} />
})


export default RelationshipToInsuredField;
